import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { CampoSpecificoConservazioneDTO } from "../dto/campo-specifico-conservazioneDTO";
import { CampoSpecificoConservazioneVO } from "../vo/campo-specifico-conservazioneVO";

@Injectable({
  providedIn: "root",
})
export class MapperCampoSpecificoConservazione
  implements
    MapperInterface<
      CampoSpecificoConservazioneDTO,
      CampoSpecificoConservazioneVO
    > {
  convertVoToDto(
    vo: CampoSpecificoConservazioneVO
  ): CampoSpecificoConservazioneDTO {
    if (vo != null) {
      const dto = new CampoSpecificoConservazioneDTO();
      dto.numeroAnni = vo.numeroAnni;
      dto.termineRiferimento = vo.termineRiferimento;
      dto.dataRiferimento = vo.dataRiferimento;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(
    dto: CampoSpecificoConservazioneDTO
  ): CampoSpecificoConservazioneVO {
    if (dto != null) {
      const vo = new CampoSpecificoConservazioneVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.numeroAnni = dto.numeroAnni;
      vo.termineRiferimento = dto.termineRiferimento;
      vo.dataRiferimento = dto.dataRiferimento;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: CampoSpecificoConservazioneVO[]
  ): CampoSpecificoConservazioneDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: CampoSpecificoConservazioneDTO[]
  ): CampoSpecificoConservazioneVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
